<template>
  <div class="search-popup" :class="{ 'is-show': selectPopupVisible }">
    <div class="search-bar">
      <input
        type="text"
        ref="searchTextInput"
        :placeholder="placeholder"
        @input="inputHandle"
        @focus="focusHandle"
        v-model="searchText"
      />
      <span @click="hide">取消</span>
    </div>
    <!-- <div class="search-con hot-box">
      <h3>{{ hotTitle }}</h3>
      <div class="clearfix">
        <span
          class="span-txt"
          v-for="item in hotData"
          v-bind:key="item"
          @click="handleSelect(item)"

        >
          {{ item }}
        </span>
      </div>
    </div> -->
    <div class="search-con hot-box" v-if="hotData.length && !searchText">
      <h3>{{ hotTitle }}</h3>
      <div class="clearfix">
        <span
          v-for="item in hotData"
          v-bind:key="item[valueKey]"
          @click="handleSelect(item)"
        >
          {{ item }}
        </span>
      </div>
    </div>
    <div class="search-con" v-else-if="searchResult.length">
      <ul>
        <li
          v-for="item in searchResult"
          v-bind:key="item[valueKey]"
          @click="handleSelect(item)"
        >
          {{ item }}
        </li>
      </ul>
    </div>
    <div class="search-con" v-else>
      <p>什么也没搜到~</p>
    </div>
  </div>
</template>

<script>
export default {
  name: "Popup",
  props: {
    focus: {
      type: Boolean,
      default: true
    },
    placeholder: {
      type: String,
      default: "请输入查询行业"
    },
    hotTitle: {
      type: String,
      default: "热门搜索"
    },
    hotData: {
      type: Array,
      default() {
        return [];
      }
    },
    data: {
      type: Array,
      default() {
        return [];
      }
    },
    labelKey: {
      type: String,
      default: "label"
    },
    valueKey: {
      type: String,
      default: "value"
    }
  },
  data() {
    return {
      selectPopupVisible: false,
      searchText: "",
      searchResult: []
    };
  },
  methods: {
    filter(v) {
      if (v) {
        this.searchResult = this.data.filter(item => {
          return item.indexOf(v) > -1;
        });
      } else {
        if (this.hotData.length && !this.focus) {
          this.searchResult = this.hotData;
        } else {
          this.searchResult = this.data;
        }
      }
    },
    inputHandle() {
      this.filter(this.searchText);
    },
    focusHandle() {
      this.filter(this.searchText);
    },
    handleSelect(val) {
      this.hide();
      this.$emit("input", val);
    },
    show() {
      document.body.style.position = "fixed";
      document.body.style.overflow = "hidden";
      this.selectPopupVisible = true;
      this.searchText = "";
      this.filter();
    },
    hide() {
      this.selectPopupVisible = false;
      document.body.style.position = "static";
      document.body.style.overflow = "auto";
    }
  },
  created() {
    this.searchResult = this.data;
  },
  watch: {
    data: function(val) {
      this.data = val;
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
.search-popup {
  width: 100%;
  height: 100%;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  padding-top: 50px;
  position: fixed;
  z-index: 9999;
  top: 0;
  left: 0;
  background: #fff;
  transform: translateX(100%);
  transition: all 0.4s;
  opacity: 0;
  &.is-show {
    transform: translateX(0);
    opacity: 1;
  }
  .search-bar {
    background: #eee;
    padding: 8px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    height: 50px;
    position: absolute;
    width: 100%;
    top: 0;
    left: 0;
    box-sizing: border-box;
    input {
      height: 18px;
      line-height: 18px;
      padding: 8px 10px;
      border-radius: 4px;
      border: none;
      width: 76%;
      &:focus {
        outline: none;
      }
    }
    span {
      display: block;
      width: 16%;
      height: 34px;
      line-height: 34px;
      text-align: center;
    }
  }
  .search-con {
    height: 100%;
    overflow-y: auto;
    ul {
      padding: 0 6px;
    }
    li {
      padding: 6px;
      line-height: 24px;
      border-bottom: 1px solid #eee;
      box-sizing: border-box;
    }
    p {
      padding: 50px 0;
      text-align: center;
      color: #ccc;
    }
  }
  .hot-box {
    padding: 14px 10px;
    box-sizing: border-box;
    h3 {
      font-weight: bold;
      font-size: 14px;
      margin-bottom: 5px;
      padding: 0 6px;
    }
    span {
      padding: 0;
      margin-bottom: 10px;
      line-height: 24px;
      width: 32%;
      display: inline-block;
      &:not(:nth-child(3n + 3)) {
        margin-right: 2%;
      }
    }
  }
}
</style>
